import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {days_to_go} from 'Skelet/src/modules/time_ago.js'
import GraphSizes from 'Skelet/src/components/GraphSizes.js'
import OnboardCard from './OnboardCard.js'


class Overview extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "sizes_list", "GET", config.api_url+"/sizes?t="+this.props.session_token);
      this.props.fetchDataIfReady(config.api_token, "journey_list", "GET", config.api_url+"/journey?t="+this.props.session_token);
      this.props.fetchDataIfReady(config.api_token, "profile", "GET", config.api_url+"/profile?t="+this.props.session_token);
    }
  }

  componentDidMount() {
    this.resizeIntroCard();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "sizes_list", "GET", config.api_url+"/sizes?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "journey_list", "GET", config.api_url+"/journey?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "profile", "GET", config.api_url+"/profile?t="+nextProps.session_token);
    }
    this.resizeIntroCard();
  }

  componentDidUpdate() {
    this.resizeIntroCard();
  }

  resizeIntroCard() {
    let elements = document.getElementsByClassName("kpi");
    if(elements.length > 1) {
      let sumcard = elements[elements.length - 1];
      let refH = elements[0].offsetHeight;
      let height_diff = refH - sumcard.children[0].offsetHeight;
      if(height_diff < 1) height_diff = 0;
      sumcard.style.padding = (height_diff/2)+"px 2em";
    }
  }

  render() {
    let current_weight = "0,0", current_weight_float = 0.0, starting_weight_float = 0.0, starting_weight = 0.0, progress = "", goal_date_txt = "", goal_weight_txt = "", total_days = 0, days_left = 0, projection_txt = "", result_txt = "", pace_txt = "", journey_card = null, user_data = this.props.apiData["login"]["data"], sizes_data = this.props.apiData["sizes_list"], journey = this.props.apiData["journey_list"], has_journey = false, has_size = false;

    if(journey !== undefined && !journey.isFetching && journey.data !== [] && journey.data[0]) has_journey = true;
    if(sizes_data !== undefined && !sizes_data.isFetching && sizes_data.data !== [] && sizes_data.data[0]) has_size = true;

    if(has_size) {
      current_weight = sizes_data.data[0].weight.toString().replace(".", ",");
      starting_weight = sizes_data.data[sizes_data.data.length - 1].weight.toString().replace(".", ",");

      current_weight_float = sizes_data.data[0].weight;
      starting_weight_float = sizes_data.data[sizes_data.data.length - 1].weight;
      if(current_weight_float < starting_weight_float || current_weight_float === starting_weight_float) {
        let weight_diff = starting_weight_float - current_weight_float;
        progress = weight_diff.toFixed(1).toString().replace(".", ",")+" kilo afgevallen";
      } else {
        let weight_diff = current_weight_float - starting_weight_float;
        progress = weight_diff.toFixed(1).toString().replace(".", ",")+" kilo aangekomen";
      }
    }

    if(has_journey) {
      let journey_data = journey.data[0];
      days_left = days_to_go(journey_data["goal_date"]);
      let sd = new Date(journey_data["start_date"]);
      let start_date_txt = sd.getDate()+" "+sd.toLocaleString('default', { month: 'long' })+" "+sd.getFullYear();
      let gd = new Date(journey_data["goal_date"]);
      goal_date_txt = gd.getDate()+" "+gd.toLocaleString('default', { month: 'long' })+" "+gd.getFullYear();
      goal_weight_txt = journey_data["goal_weight"].toString().replace(".", ",");
      let weight_left = 0.0;
      let weight_lost = 0.0;
      if(sizes_data !== undefined && !sizes_data.isFetching && sizes_data.data !== [] && sizes_data.data[0]) {
        weight_left = sizes_data.data[0].weight - journey_data["goal_weight"];
        weight_lost = journey_data["start_weight"] - sizes_data.data[0].weight;
      }
      total_days = days_to_go(journey_data["goal_date"], journey_data["start_date"]);
      let total_weight = journey_data["start_weight"] - journey_data["goal_weight"];
      let goal_weight_today = journey_data["start_weight"] - ((total_weight / total_days) * (total_days - days_left));
      let goal_weight_today_mh = goal_weight_today + 3;
      let goal_weight_today_ml = goal_weight_today - 3;
      let time_left = <span>{days_left} dagen / {(days_left / 7).toFixed(1).replace(".", ",")} weken</span>;
      let wl_weekly = Math.ceil(weight_left.toFixed(1) / (days_left / 7) * 1000);
      let wl_speed_warning = (wl_weekly > 1000) ? true : false;
      let wl_grams = <span>{Math.ceil(weight_left.toFixed(1) / days_left * 1000).toString().replace(".", ",")} gram per dag / {wl_weekly.toString().replace(".", ",")} per week</span>;
      if(days_left < 1) time_left = "0 dagen / 0 weken";
      if(days_left < 1) wl_speed_warning = true; // always display in red if plan is expired
      if(days_left < 1) wl_grams = "Plan is verlopen, maak een nieuw plan aan bij de Lichaam-pagina!";

      journey_card = <div className="card">
        <h1>Plan</h1>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Startgewicht</div>
          <div className="card-layout-div75">{journey_data["start_weight"].toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({start_date_txt})</small></div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Huidig gewicht</div>
          <div className="card-layout-div75">{current_weight} kg</div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Streefgewicht</div>
          <div className="card-layout-div75">{journey_data["goal_weight"].toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({goal_date_txt})</small></div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Streefgewicht vandaag</div>
          <div className="card-layout-div75">{goal_weight_today.toFixed(1).toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({goal_weight_today_ml.toFixed(1).toString().replace(".", ",")} - {goal_weight_today_mh.toFixed(1).toString().replace(".", ",")} kg)</small></div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Kilo's afgevallen</div>
          <div className="card-layout-div75">{weight_lost.toFixed(1).toString().replace(".", ",")} kg</div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Kilo's te gaan</div>
          <div className="card-layout-div75">{weight_left.toFixed(1).toString().replace(".", ",")} kg</div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Tijd te gaan</div>
          <div className="card-layout-div75">{time_left}</div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Gram per dag / week</div>
          <div className="card-layout-div75" style={wl_speed_warning ? {color:"#ff6353"} : null}>{wl_grams}</div>
        </div>
      </div>;
    }

    if(has_journey && has_size) {
      let journey_start_weight_float = journey.data[0]["start_weight"];
      let projection = (journey_start_weight_float - current_weight_float) / (total_days - days_left) * days_left;
      if(total_days === days_left || ((total_days - days_left) < 8)) projection = journey.data[0]["start_weight"] - journey.data[0]["goal_weight"];
      projection_txt = projection.toFixed(2).toString().replace(".", ",");
      result_txt = (current_weight_float - projection).toFixed(1).toString().replace(".", ",");
      pace_txt = (projection / days_left * 7).toFixed(3).toString().replace(".", ",");
    }

    let greeting = "";
    var now = new Date();
    let h = now.getHours();
    if(h >= 5 && h < 12) {
      greeting = "Goedemorgen";
    } else if(h >= 12 && h < 18) {
      greeting = "Goedemiddag";
    } else {
      greeting = "Goedenavond";
    }
    let intro_content = <div><h1>{greeting}, {user_data["firstname"]}!</h1></div>;
    if(current_weight_float > 0 && goal_weight_txt !== "") {
      intro_content = <div><h1>{greeting}, {user_data["firstname"]}!</h1><p>Je weegt momenteel <i>{current_weight} kilo</i> en wil op {goal_date_txt} <b>{goal_weight_txt} kilo</b> wegen. Op dit moment ben je <b>{progress}</b>, met een startgewicht van <i>{starting_weight} kilo</i>.</p></div>;
    } else if(current_weight_float > 0) {
      intro_content = <div><h1>{greeting}, {user_data["firstname"]}!</h1><p>Je weegt momenteel <i>{current_weight} kilo</i> en hebt nog geen streefgewicht ingevuld.</p></div>;
    }
    let intro_card = <div className="card kpi" style={{background:"#000"}}>{intro_content}</div>;

    let display_graph = has_size || has_journey;

    return (
      <div className="container" ref={this.setWrapperRef} style={{marginTop:"2em"}}>
        <OnboardCard />
        {has_size && <div className="card kpi"><h3>Vooruitgang</h3><h1>{progress}</h1><h3>&nbsp;</h3></div>}
        {has_journey && <div className="card kpi" style={{background:"linear-gradient(0deg, rgb(229, 175, 251) 0%, rgb(197, 73, 249) 100%)"}}><h3>Streefgewicht</h3><h1>{goal_weight_txt} kg</h1><h3>{goal_date_txt}</h3></div>}
        {has_journey && has_size && <div className="card kpi" style={{background:"linear-gradient(0deg, rgb(229, 175, 251) 0%, rgb(197, 73, 249) 100%)"}}><h3>Projectie</h3><h1>{result_txt} kg</h1><h3>-{projection_txt} kg</h3><h4>{pace_txt} kg/wk</h4></div>}
        {intro_card}
        {display_graph && <GraphSizes data={sizes_data.data} goal_data={journey.data} />}
        {journey_card}
      </div>
    );
  }


}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Overview)



// WEBPACK FOOTER //
// ./src/containers/Overview.js